'use client';

import React, { useState, useContext, createContext, useEffect } from 'react';

interface AppContextProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AppContext = createContext<AppContextProps>({
  mobileMenuOpen: false,
  setMobileMenuOpen: () => null,
});

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Cross-tab company switching synchronization
  useEffect(() => {
    let needsRefresh = false;

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'company-switch-trigger') {
        // Mark this tab as needing refresh instead of immediate reload
        needsRefresh = true;
      }
    };

    const handleFocus = () => {
      if (needsRefresh) {
        needsRefresh = false;
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  return (
    <AppContext.Provider
      value={{
        mobileMenuOpen,
        setMobileMenuOpen,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};
